<div *ngIf="loading" class="graph loading" id="loading " [chart]="measureBlankChart"></div>
<table class="reportArea">
  <tr>
    <td class="reportPanel" *ngIf="(showReport == 'total' || showReport == 'all') && !loading">
      <div class="graph" id="detail" [chart]="measureTotalChart" [class.loading]="loading"></div>
    </td>
    <td class="reportPanel" *ngIf="(showReport == 'average' || showReport == 'all') && !loading">
      <div class="graph" id="detail" [chart]="measureAverageChart" [class.loading]="loading"></div>
    </td>
  </tr>
</table>
